import { cpf } from 'cpf-cnpj-validator';

const validate = (values, { t }) => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = t('validations.required');
  }

  if (!values.lastName) {
    errors.lastName = t('validations.required');
  }

  if (!values.shortName) {
    errors.shortName = t('validations.required');
  }

  if (!values.dateOfBirth) {
    errors.dateOfBirth = t('validations.required');
  }
  if (!values.studentOrigin) {
    errors.studentOrigin = t('validations.required');
  }
  if (values.legacyId) {
    const regex = /[a-zA-Z\u00C0-\u00FF ]+/i;
    if (values.legacyId.length > 10) {
      errors.legacyId = t('validations.ten-number-overflow');
    }
    if (regex.test(values.legacyId)) {
      errors.legacyId = t('validations.only-number');
    }
  }
  if (values.cpf) {
    const cpfIsValid = cpf.isValid(values.cpf);
    if (!cpfIsValid) {
      errors.cpf = t('validations.enter-valid-cpf');
    }
  }
  return errors;
};

export default validate;
